import { useMembershipIds } from "./useMembershipIds"

export const useLimitless = (): {
  hasLimitlessEnabled: boolean
  annualLimitlessMembershipId: string
  freeTrialLimitlessMembership30Id: string
} => {
  const { annualLimitlessMembershipId, freeTrialLimitlessMembership30Id } =
    useMembershipIds()

  return {
    hasLimitlessEnabled: true,
    annualLimitlessMembershipId,
    freeTrialLimitlessMembership30Id,
  }
}
